/**
 * Component: Anchors
 * 
 */
'use strict';

window.addEventListener('DOMContentLoaded', () => {
  initAnchors();
});

const initAnchors = () => {
  if ( ! document.body.classList.contains('single-post') &&
       ! document.body.classList.contains('single-sd-integration') &&
       ! document.body.classList.contains('single-sd-learning-center') )
    return;

  setAnchorAccordion();
  detectScroll();
  checkNavPinnedStatus();
  setActiveLinkTOC();
  syncTOCWithDefaultScrollbar();
}

/**
 * Set anchors wrapper accordion
 *
 */
const setAnchorAccordion = () => {
  $('#nav-links-desktop-content').on('hide.bs.collapse', function( e )
  {
    $(this).parent().addClass('hide');
  });

  $('#nav-links-desktop-content').on('show.bs.collapse', function( e )
  {
    $(this).parent().removeClass('hide');
  });
}

/**
 * Detect scroll down and collapse nav
 * 
 */
const detectScroll = () => {
  let last_top = 0;

  document.addEventListener('scroll', () => {
    let scroll_top = window.pageYOffset || document.documentElement.scrollTop;

    if ( scroll_top > last_top && $('#nav-links-desktop').hasClass('is-pinned') ) {
      $('#nav-links-desktop-content').collapse('hide');
      $('#nav-links-desktop').addClass('closed');
    }

    last_top = scroll_top;
  });
}

/**
 * Check blog single subnav pinned (sticky) status
 *
 * Watch for when nav becomes sticky and add '.is-pinned' class to trigger style transitions
 */
const checkNavPinnedStatus = () => {
  const anchors = document.getElementById('nav-links-desktop');

  if ( ! anchors ) {
    return;
  }

  // Pass admin bar height to script if being shown 
  const admin_bar_offset = document.getElementById('wpadminbar') ?  32 : 0;

  // Create negative offset based on rendered nav height + adminbar height
  var nav_offset = document.querySelector("#main-navigation").clientHeight + admin_bar_offset;

  document.addEventListener('scroll', () => {
    if ( anchors.getBoundingClientRect().top <= nav_offset ) {
      anchors.classList.add('is-pinned');
    }
    else {
      anchors.classList.remove('is-pinned'); 
    }
  });
}

/**
 * Learn Cloud Native: Add active class to Table of Contents when heading with a matching ID is in view
 * 
 */
const setActiveLinkTOC = () => {
  const navLinks = document.querySelectorAll('#nav-links-floating-toc a');
  if (!navLinks.length) return;

  let currentActive = null;
  let visibleSections = {};

  const sectionObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            visibleSections[entry.target.id] = entry.target;
        } else {
            delete visibleSections[entry.target.id];
        }
    });

    const topMostSection = Object.values(visibleSections).sort((a, b) => a.offsetTop - b.offsetTop)[0];

    if (topMostSection) {
        const newActiveLink = document.querySelector(`#nav-links-floating-toc a[href="#${topMostSection.id}"]`);
        if (newActiveLink && newActiveLink !== currentActive) {
            if (currentActive) {
                currentActive.classList.remove('active');
            }
            newActiveLink.classList.add('active');
            currentActive = newActiveLink;
        }
    }
  }, {
    root: null,
    rootMargin: '0px',
    threshold: 1
  });

  const handeTocResize = () => {
    visibleSections = {};
    document.querySelectorAll('h2.wp-block-heading').forEach(section => {
        sectionObserver.unobserve(section);
        sectionObserver.observe(section);
    });
  };

  document.querySelectorAll('h2.wp-block-heading').forEach(section => {
    sectionObserver.observe(section);
  });

  window.addEventListener('resize', handeTocResize);
}

const syncTOCWithDefaultScrollbar = () => {
    const toc = document.querySelector('#nav-links-floating-toc');
    const tocTitle = document.querySelector('.t-v4-learn-cloud--content--floating-toc-title');

    if (!toc || !tocTitle) {
        return;
    }

    const totalScrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
    const tocScrollableHeight = toc.scrollHeight - toc.clientHeight;
    const titleOffset = tocTitle.offsetHeight + 16;

    const syncScroll = () => {
        const mainScrollRatio = window.scrollY / totalScrollableHeight;
        let tocScrollPosition = mainScrollRatio * tocScrollableHeight;

        tocScrollPosition -= titleOffset;
        tocScrollPosition = Math.max(tocScrollPosition, 0); // Prevent negative scroll
        tocScrollPosition = Math.min(tocScrollPosition, tocScrollableHeight); // Prevent overscrolling past the bottom

        toc.scrollTop = tocScrollPosition;
    };

    window.addEventListener('scroll', syncScroll);
    syncScroll();
};
